import React, { useEffect, useState } from 'react'
import Main from '../Components/Main';
import PageContainer from '../Components/PageContainer';
import VendorForm from '../Components/VendorForm';
import VendorList from '../Components/VendorList';
import CollapseCard from '../Components/CollapseCard';
import Modal from '../Components/Modal';
import { useToast } from '../Components/toast/ToastProvider';
import { deleteVendor, getAllVendors, saveVendor } from '../Service/VendorService';

const VendorPage = () => {
    const [vendorData, setVendorData] = useState([]);
    const [vendorForm, setVendorForm] = useState({
        code: '',
        name: '',
        location: '',
        contact_number: ''
    });
    const [showModal, setShowModal] = useState(false);
    const toast = useToast();


    useEffect(() => {
        fetchVendor();
    }, []);
    const fetchVendor = async () => {
        try {
            const res = await getAllVendors();
            setVendorData(res.data);;
        } catch (err) {
            toast(err.message || 'failed to fetch vendor', "ERROR")

        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!vendorForm.code || !vendorForm.name || !vendorForm.location || !vendorForm.contact_number) {
            toast('Please fill all fields', "ERROR");
            return;
        }

        const duplicateCode = vendorData.some((item) => item.id !== vendorForm.id &&  item.code?.trim() === vendorForm.code?.trim() )
        if(duplicateCode){
            toast("Vendor code already exists","ERROR");
            return;
        }


         const duplicateData = vendorData.some((item) =>
          item.id !== vendorForm.id && item.name?.trim().toLowerCase() === vendorForm.name?.trim().toLowerCase());

        if (duplicateData) {
           toast("Vendor name already exists", "ERROR");
         return;
       }

        try {
            const payload = vendorForm.id ? { id: vendorForm.id, code: vendorForm.code, name: vendorForm.name, location: vendorForm.location, contact_number: vendorForm.contact_number } : { code: vendorForm.code, name: vendorForm.name, location: vendorForm.location, contact_number: vendorForm.contact_number }
            await saveVendor(payload);

            toast(vendorForm.id ? 'Vendor Update successfully' : 'Vendor added successfully');
            fetchVendor();
            handleCancel();
        } catch (err) {
            toast(err.message || 'Failed to save Vendor', "ERROR")

        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "contact_number") {
            // Remove non-digit characters
            let numericValue = value.replace(/\D/g, "");
            // Limit to 10 digits
            if (numericValue.length > 10) {
                numericValue = numericValue.slice(0, 10);
            }
            setVendorForm((prev) => ({ ...prev, [name]: numericValue }));
        } else {
            setVendorForm((prev) => ({ ...prev, [name]: value }));
        }
    };


    const handleEdit = (item) => {
        setVendorForm({ id: item.id, code: item.code, name: item.name, location: item.location, contact_number: item.contact_number });
        setShowModal(true);
    };

    // const handleDelete = async (index) => {
    //     if (!window.confirm('Are you sure you want to delete this vendor?')) return
    //     try {
    //         await deleteVendor(vendorData[index].id)
    //         toast('vendor deleted successfully', "SUCCESS")
    //         fetchVendor();
    //     } catch (err) {
    //         toast(err.message || 'Failed to delete vendor', "ERROR")
    //     }
    // };

    const handleCancel = () => {
        setVendorForm({
            code: '',
            name: '',
            location: '',
            contact_number: '',
        })
        setShowModal(false);

    }
    return (
        <>
            <Main>
                <PageContainer
                    titlePage='Vendor'
                    buttonText={'ADD'}
                    onButtonClick={() => {
                        setShowModal(true);
                    }}
                >
                    <Modal
                        visible={showModal}
                        size='lg'
                        onClose={handleCancel}
                        headerText={vendorForm.id ? 'Edit Vendor' : 'Add Vendor'}

                    >
                        <VendorForm
                            handleChange={handleChange}
                            vendorForm={vendorForm}
                            handleSubmit={handleSubmit}
                            handleCancel={handleCancel}
                        />
                    </Modal>
                    <CollapseCard title='Vendor'>
                        <VendorList
                            vendorData={vendorData}
                            handleEdit={handleEdit}
                            // handleDelete={handleDelete}
                             />
                    </CollapseCard>
                </PageContainer>

            </Main>

        </>
    )
}

export default VendorPage
